import { gql as t } from "@apollo/client";
import { LoginAccountFragment as n } from "../fragment/account.js";
const l = t`
  mutation BindWalletAddress($input: LoginByWalletInput!) {
    bindWalletAddress(input: $input) {
      ...LoginAccount
    }
  }

  ${n}
`;
export {
  l as default
};
//# sourceMappingURL=bindWalletAddress.js.map
